import { render, staticRenderFns } from "./StepCreatedProject.vue?vue&type=template&id=be629a9c&scoped=true&"
import script from "./StepCreatedProject.vue?vue&type=script&lang=js&"
export * from "./StepCreatedProject.vue?vue&type=script&lang=js&"
import style0 from "./StepCreatedProject.vue?vue&type=style&index=0&id=be629a9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be629a9c",
  null
  
)

export default component.exports